const scheduleSetting = {
  data () {
    return {
      // 穿梭窗配置
      transferSetting: {
        dialogWidth: "1300px",
        tableWidth: 522,
        tableHeight: 530
      },
      tableColums: [
        { prop: "campusName", label: "所属校区", width: 120 },
        { prop: "subjectCourseName", label: "所属科目", width: 150 },
        { prop: "className", label: "班级", width: 150 },
        { prop: "syncCountClassCourse", label: "同步次数", width: 80 },
        { prop: "syncDateLastClassCourse", label: "最近同步时间", width: 180 }
      ],
      transferCampusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
        emitPath: false
      },
      campusList: [],
      transSubjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false
      },
      scheduleSettingSearchForm: {
        campusIds: undefined,
        subjectCourseId: undefined,
        pageSize: 10,
        pageNumber: 1,
        planId: undefined,
        notId: undefined
      }
    };
  },
  methods: {
    getScheduleSetting (id) {
      if (!id) return;
      this.api.scheduleSetting
        .getScheduleSetting({ classInfoId: id })
        .then(res => {
          if (res.data) {
            this.scheduleSettingSearchForm.planId = res.data.planId;
          } else {
            this.scheduleSettingSearchForm.planId = undefined;
          }
          this.scheduleSettingSearchForm.notId = id;
        });
    },
    showscheduleDialog () {
      // 初始化数据
      this.scheduleSettingSearchForm.campusIds = undefined;
      this.scheduleSettingSearchForm.subjectCourseId = undefined;
      this.scheduleSettingSearchForm.pageSize = 10;
      this.scheduleSettingSearchForm.pageNumber = 1;
      this.$refs.transfer.initData();
    },
    getScheduleClassInfoList () {
      let obj = Object.assign({}, this.scheduleSettingSearchForm);
      this.api.scheduleSetting.getClassInfoList(obj).then(res => {
        if (res.data.records) {
          this.$refs.transfer.pageParam = {
            list: res.data.records,
            pageSize: this.scheduleSettingSearchForm.pageSize,
            pageNumber: this.scheduleSettingSearchForm.pageNumber,
            total: res.data.total
          };
        } else {
          this.$refs.transfer.pageParam = {
            list: [],
            pageSize: this.scheduleSettingSearchForm.pageSize,
            pageNumber: this.scheduleSettingSearchForm.pageNumber,
            total: res.data.total
          };
        }
      });
    },
    getCopyList (arr) {
      console.log(arr);
      let beCopyClassInfoIdList = arr.map(item => {
        return item.id;
      });
      this.api.scheduleSetting
        .batchCopyCourseByClassInfo({
          copyClassInfoId: this.scheduleSettingSearchForm.notId,
          beCopyClassInfoIdList
        })
        .then(res => {
          if (res.code == 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
          this.$refs.transfer.dialogVisible = false;
        });
    }
  }
};
export { scheduleSetting };



// WEBPACK FOOTER //
// ./src/components/classRoomTeaching/mixin/scheduleSetting.js